module.exports = __webpack_public_path__ + "static/media/yaken.44319d66.png";